import { ActionContext, ActionTree } from 'vuex';
import {
    SET_NONPROFIT_PROFILE_DATA,
    SET_ORG_KEY,
    SET_OPPORTUNITY,
    SET_COMPANY_ABOUT,
    SET_COMPANY_MISSION,
    ADD_COMPANY_PROGRAM,
    EDIT_COMPANY_PROGRAM,
    ADD_COMPANY_HISTORY,
    EDIT_COMPANY_HISTORY,
    SET_SOCIAL_MEDIA,
    SET_FAVORITES,
    SET_COMPANY_MEDIA,
    DELETE_COMPANY_HISTORY,
    DELETE_COMPANY_PROGRAM,
    DELETE_MEMBER_POSITION,
    ADD_MEMBER_POSITION,
    DELETE_OPPORTUNITY,
    SET_NONPROFIT_LOCATIONS,
    SET_NONPROFIT_CAUSES_DATA,
    SET_ALL_PRIORITY_LEVEL,
    SET_SHORTLISTED_OPPORTUNITY
} from './mutation-types';
import State from './state';
import RootState from '../../state'
import nonprofitProfileService from '../../../services/nonprofitProfileService'
import commonService from '../../../services/commonService'
import camelizer from '../../../../../../services/convertDataStrategies/classes/camelizer';
import { Opportunity } from '../../../models/classes/nonprofitProfile/opportunity';
import { TextCard } from '../../../models/classes/nonprofitProfile/textCard';
import { IAddEditSocialMediaOutput } from '../../../models/interfaces/iAddEditSocialMediaOutput';
import { ISocialNetwork } from '../../../models/interfaces/iSocialNetwork';
import { IAddEditMediaOutput } from '../../../models/interfaces/nonprofitProfile/iAddEditMediaOutput';
import { Media } from '../../../models/classes/nonprofitProfile/media';
import { IDeleteMemberCardOutput } from '../../../models/interfaces/iDeleteMemberCardOutput';
import { IAddMemberCardOutput } from '../../../models/interfaces/iAddMemberCardOutput';
import { MemberOrganisationCard } from '../../../models/classes/memberOrganisationCard';
import { IMemberOrganisationCard } from '../../../models/interfaces/iMemberOrganisationCard';
import { IAddEditLocationsOutput } from '../../../models/interfaces/iAddEditLocationOutput';
import { IAddOpportunityOutput } from '../../../models/interfaces/nonprofitProfile/iAddOpportunityOutput';
import { ICause } from "../../../models/interfaces/iCause";
import { INonprofitFansRequestNewPortionData } from "../../../models/interfaces/nonprofitProfile/iNonprofitFansRequestNewPortionData";
import { IOpportunity } from '../../../models/interfaces/nonprofitProfile/iOpportunity';
import { IOpportunities } from '../../../models/interfaces/nonprofitProfile/iOpportunities';

// ActionTree<[current state], [root state]>
const actions: ActionTree<State, RootState> = {

    getNonprofitProfileData({commit, state}: ActionContext<State, RootState>, key: string): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.getNonprofitProfileData(key).then((rsp: any) => {
                commit(SET_NONPROFIT_PROFILE_DATA, camelizer.convert(rsp.data?rsp.data.nonprofit:{}));
            }).catch((error: any) => reject(error));
        })
    },

    getAllPriorityLevel({commit, state}: ActionContext<State, RootState>): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.getAllPriorityLevel().then((rsp: any) => {
                commit(SET_ALL_PRIORITY_LEVEL, rsp);
            }).catch((error: any) => reject(error));
        })
    },

    setOrgKey({commit}: ActionContext<State, RootState>, key: string) {
        return new Promise((resolve, reject) => {
            commit(SET_ORG_KEY, key);
            resolve(true);
        });
    },

    //getNonprofitProfileData({ commit, state }: ActionContext<State, RootState>, key: string): void {

    //	nonprofitProfileService.getNonprofitProfileData(key).then((rsp: any) => {
    //		commit(SET_NONPROFIT_PROFILE_DATA, camelizer.convert(rsp.data.nonprofit));
    //	});
    //},

    async postOpportunity({commit, state}: ActionContext<State, RootState>, opportunityData: any): Promise<any> {
        const {data} = await nonprofitProfileService.addOpportunity(opportunityData);
        commit(SET_OPPORTUNITY, new Opportunity(camelizer.convert(data.opportunity) as IOpportunity));
    },

    updateOpportunity({commit, state, dispatch}: ActionContext<State, RootState>, opportunityData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.updateOpportunity(opportunityData)
                .then((res: any) => {
                    dispatch('getNonprofitProfileData', opportunityData.orgKey)
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    addEditAboutUs({commit}: ActionContext<State, RootState>, aboutUsData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.addEditAboutUs(aboutUsData)
                .then((res: any) => {
                    commit(SET_COMPANY_ABOUT, aboutUsData);
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    addEditOurMission({dispatch, commit}: ActionContext<State, RootState>, missionData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.addEditOurMission(missionData)
                .then((res: any) => {
                    commit(SET_COMPANY_MISSION, missionData.mission)
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        })
    },

    addCompanyProgram({commit}: ActionContext<State, RootState>, programData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.addCompanyProgram(programData)
                .then((res: any) => {
                    const newProgram = programData;
                    newProgram.key = res.key;

                    commit(ADD_COMPANY_PROGRAM, new TextCard(newProgram));
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    editCompanyProgram({commit}: ActionContext<State, RootState>, programData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.editCompanyProgram(programData)
                .then((res: any) => {
                    commit(EDIT_COMPANY_PROGRAM, programData)
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    setCauses({commit}: ActionContext<State, RootState>, data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.changeCauses(data).then((rsp) => {
                const changedCauses: ICause[] = <ICause[]>camelizer.convert(rsp.data.causes);
                commit(SET_NONPROFIT_CAUSES_DATA, changedCauses)
            })
        });
    },

    deleteCompanyProgram({commit}: ActionContext<State, RootState>, programData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.deleteCompanyCard(programData)
                .then((res: any) => {
                    commit(DELETE_COMPANY_PROGRAM, programData)
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    addCompanyHistory({commit}: ActionContext<State, RootState>, historyData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.addCompanyHistory(historyData)
                .then((res: any) => {
                    const newHistory = historyData;
                    newHistory.key = res.key;

                    commit(ADD_COMPANY_HISTORY, new TextCard(newHistory));
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    deleteCompanyHistory({commit}: ActionContext<State, RootState>, historyData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.deleteCompanyCard(historyData)
                .then((res: any) => {
                    commit(DELETE_COMPANY_HISTORY, historyData)
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    editCompanyHistory({commit}: ActionContext<State, RootState>, historyData: any): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.editCompanyHistory(historyData)
                .then((res: any) => {
                    commit(EDIT_COMPANY_HISTORY, historyData);
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    addEditSocialMedia({commit}: ActionContext<State, RootState>, socialMediaData: IAddEditSocialMediaOutput): Promise<any> {
        return new Promise((resolve, reject) => {
            commonService.changeOrganizationSocialMedia(socialMediaData)
                .then((res: any) => {
                    const socialMedia = socialMediaData.socialMedia.map((el: any) => {
                        el.imgUrl = '';

                        return el;
                    });

                    commit(SET_SOCIAL_MEDIA, socialMedia);
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    setFavorites({commit}: ActionContext<State, RootState>, orgKey: string): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.setFavorites(orgKey)
                .then((res: any) => {
                    const isFan = res.data.is_fan;

                    commit(SET_FAVORITES, isFan);
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },


    addEditCompanyMedia({commit}: ActionContext<State, RootState>, mediaData: IAddEditMediaOutput): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.addEditCompanyMedia(mediaData)
                .then((res: any) => {
                    const newMedia = new Media({title: mediaData.mediaTitle, url: mediaData.mediaUrl});

                    commit(SET_COMPANY_MEDIA, newMedia);
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    deleteMemberPosition({commit}: ActionContext<State, RootState>, memberData: IDeleteMemberCardOutput): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.deleteMemberPosition(memberData.memberOrgKey)
                .then((res: any) => {
                    commit(DELETE_MEMBER_POSITION, memberData)
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },


    addMemberPosition({commit, dispatch}: ActionContext<State, RootState>, data: { type: string, data: IAddMemberCardOutput }): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.addMemberPosition(data.data)
                .then((res: any) => {
                    if (!!res.data.members) {
                        const members = res.data.members.map((el: IMemberOrganisationCard) => new MemberOrganisationCard(el));
                        commit(ADD_MEMBER_POSITION, {members: members, type: data.type});
                    }

                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    deleteOpportunity({commit}: ActionContext<State, RootState>, data: { type: string, key: string }): Promise<any> {
        return new Promise((resolve, reject) => {
            nonprofitProfileService.deleteOpportunity(data.key)
                .then((res: any) => {
                    commit(DELETE_OPPORTUNITY, data)
                    resolve(res);
                })
                .catch((error: any) => reject(error));
        });
    },

    setNonprofitLocations({ commit, dispatch }: ActionContext<State, RootState>, data: IAddEditLocationsOutput) {
        // debugger;
        return new Promise((resolve, reject) => {
            commonService.changeOrganizationLocations(data).then((rsp: any) => {
                // debugger;
                const locations = camelizer.convert(rsp.data.locations);

                commit(SET_NONPROFIT_LOCATIONS, locations);
                resolve(rsp.data);
            });
        });
    },

    changNonprofitProfile({commit, dispatch,}: ActionContext<State, RootState>, orgKey: string) {
        return new Promise((resolve, reject) => {
            dispatch('setOrgKey', orgKey);
            resolve(dispatch('getNonprofitProfileData', orgKey));
        });
    },

    async updateShortlistedOpportunity({commit, state}: ActionContext<State, RootState>, opportunityData: any): Promise<any> {
        const {data} = await nonprofitProfileService.updateShortlistedOpportunity(opportunityData);

    // return new Promise((resolve, reject) => {
    //     nonprofitProfileService.updateShortlistedOpportunity(opportunityData).then((rsp: any) => {
    //         console.log(rsp.opportunities);
    //         commit(SET_SHORTLISTED_OPPORTUNITY, camelizer.convert(rsp?rsp.opportunities:{}));
    //     }).catch((error: any) => reject(error));
    // })

        // commit(SET_SHORTLISTED_OPPORTUNITY, new Opportunity(camelizer.convert(data.opportunities) as IOpportunity));
    },

    async getNonprofitFans({commit}: ActionContext<State, RootState>, fansOutput: INonprofitFansRequestNewPortionData) {
        const {data} = await nonprofitProfileService.getNonprofitFans(fansOutput)
        const result = camelizer.convert(data);

        return result;
    },
};

export default actions;



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/nonprofit/actions.ts